import type { WhatsNewDataItem } from '@/features/userManual/components/WhatsNew/types';
import { RIO_PRICE_LIST_URL } from '@/lib/constants';

export const whatsNewData: WhatsNewDataItem[] = [
    {
        version: 'whatsNew.releaseNotes07.version',
        date: '12.10.2026',
        content: {
            title: 'whatsNew.releaseNotes07.title',
            descriptionItems: [{ key: 'whatsNew.releaseNotes07.description1' }],
            image: { src: '/whatsNew/releaseNotes07.gif', alt: 'whatsNew.releaseNotes07.alt' },
        },
    },
    {
        version: 'whatsNew.releaseNotes06.version',
        date: '22.09.2026',
        content: {
            title: 'whatsNew.releaseNotes06.title',
            descriptionItems: [{ key: 'whatsNew.releaseNotes06.description1' }],
            image: { src: '/whatsNew/releaseNotes06.gif', alt: 'whatsNew.releaseNotes06.alt' },
        },
    },
    {
        version: 'whatsNew.releaseNotes05.version',
        date: '06.07.2026',
        content: {
            title: 'whatsNew.releaseNotes05.title',
            descriptionItems: [{ key: 'whatsNew.releaseNotes05.description1' }],
            image: { src: '/whatsNew/releaseNotes05.webp', alt: 'whatsNew.releaseNotes05.alt' },
        },
    },
    {
        version: 'whatsNew.releaseNotes04.version',
        date: '14.05.2026',
        content: {
            title: 'whatsNew.releaseNotes04.title',
            descriptionItems: [
                { key: 'whatsNew.releaseNotes04.description1' },
                { key: 'whatsNew.releaseNotes04.description2' },
            ],
            image: { src: '/whatsNew/releaseNotes04.webp', alt: 'whatsNew.releaseNotes04.alt' },
        },
    },
    {
        version: 'whatsNew.releaseNotes03.version',
        date: '24.03.2026',
        content: {
            title: 'whatsNew.releaseNotes03.title',
            descriptionItems: [{ key: 'whatsNew.releaseNotes03.description1' }],
            image: { src: '/whatsNew/releaseNotes03.gif', alt: 'whatsNew.releaseNotes03.alt' },
            isReleaseNotes: true,
        },
    },
    {
        version: 'whatsNew.releaseNotes02.version',
        date: '11.12.2025',
        content: {
            title: 'whatsNew.releaseNotes02.title',
            descriptionItems: [{ key: 'whatsNew.releaseNotes02.description1' }],
            image: { src: '/whatsNew/releaseNotes02.gif', alt: 'whatsNew.releaseNotes02.alt' },
            isReleaseNotes: true,
        },
    },
    {
        version: 'whatsNew.releaseNotes01.version',
        date: '29.10.2025',
        content: {
            title: 'whatsNew.releaseNotes01.title',
            descriptionItems: [{ key: 'whatsNew.releaseNotes01.description1' }],
            image: { src: '/whatsNew/releaseNotes01.gif', alt: 'whatsNew.releaseNotes01.alt' },
            isReleaseNotes: true,
        },
    },
    {
        version: 'whatsNew.news01.version',
        date: '06.08.2025',
        content: {
            title: 'whatsNew.news01.title',
            descriptionItems: [
                { key: 'whatsNew.news01.description1' },
                { key: 'whatsNew.news01.description2', link: RIO_PRICE_LIST_URL },
            ],
            image: { src: '/whatsNew/news01Big.webp', alt: 'whatsNew.news01.alt' },
        },
    },
];
